export default __webpack_public_path__ + "static/media/img3.c7550691.avif";